import {isNumberString} from '../number/is-number-string.util';

function decodeValue(value: string): any {
  if (value === 'true') {
    return true;
  } else if (value === 'false') {
    return false;
  }
  const v = decodeURIComponent(value);
  if (isNumberString(v)) {
    return Number(v);
  } else {
    return v;
  }
}

export function decodeQuery(queryString: string): { [ key: string ]: any } {
  let qs = queryString;
  if (qs.indexOf('?') === 0) {
    qs = qs.slice(1);
  }
  return qs.split('&').reduce((queryParams, currentString) => {
    const [ key, value ] = currentString.split('=');
    queryParams[ key ] = decodeValue(value);
    return queryParams;
  }, {});
}
